import { supabase } from '../supabase';
import { recordOpportunityActivity } from '../opportunityActivities';

/**
 * Record a phone_call CRM activity for open opportunities — same pattern as
 * SMS in messaging.ts (client-side insert + mark read + UI event).
 * Used when the user places/starts a call from the app.
 */
export async function recordPhoneCallOpportunityActivity(params: {
  businessId: string;
  phoneNumber: string;
  customerId?: string | null;
  direction?: 'outbound' | 'inbound';
  callStatus?: string;
}): Promise<void> {
  const { businessId, phoneNumber, direction = 'outbound', callStatus = 'ringing' } = params;
  if (!supabase || !businessId || !phoneNumber) return;

  try {
    let customerId = params.customerId || undefined;

    if (!customerId) {
      const normalizedPhone = phoneNumber.replace(/\D/g, '');
      const last10 = normalizedPhone.slice(-10);
      if (last10.length < 10) return;

      const { data: matchingCustomers, error } = await supabase
        .from('customers')
        .select('id, phone')
        .eq('business_id', businessId)
        .not('phone', 'is', null);

      if (error || !matchingCustomers?.length) return;

      const match = matchingCustomers.find((c) => {
        if (!c.phone) return false;
        const customerDigits = c.phone.replace(/\D/g, '');
        return (
          customerDigits.slice(-10) === last10 ||
          customerDigits === normalizedPhone ||
          customerDigits === normalizedPhone.substring(1) ||
          `1${customerDigits}` === normalizedPhone
        );
      });

      if (!match) return;
      customerId = match.id;
    }

    await recordOpportunityActivity({
      businessId,
      customerId,
      activityType: 'phone_call',
      activityData: {
        call_direction: direction,
        phone_number: phoneNumber,
        call_status: callStatus,
      },
    });
  } catch (error) {
    console.error('[Call Activity] Error recording opportunity activity:', error);
  }
}
